import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { motion, AnimatePresence } from "framer-motion";
import { Sparkles, X } from "lucide-react";
import { Link } from "react-router-dom";

const LS_KEY = "oresto-launch-offer-dismissed";

export default function LaunchOfferBanner() {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined") return;
    const dismissed = window.localStorage.getItem(LS_KEY);
    if (!dismissed) setVisible(true);
  }, []);

  const dismiss = () => {
    setVisible(false);
    try { window.localStorage.setItem(LS_KEY, "1"); } catch {}
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ y: -60, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: -60, opacity: 0 }}
          transition={{ duration: 0.4 }}
          className="bg-gradient-to-r from-[#2A7D5F] to-[#1F5E47] text-white relative z-40"
          data-testid="launch-offer-banner"
        >
          <div className="max-w-6xl mx-auto px-4 sm:px-6 py-2.5 flex items-center justify-between gap-3">
            <div className="flex items-center gap-2 sm:gap-3 flex-1 min-w-0">
              <Sparkles className="w-4 h-4 text-[#F5D57E] shrink-0" strokeWidth={2.2} />
              <p className="text-xs sm:text-sm truncate">
                <strong>{t("launch.title")}</strong>{" "}
                <span className="hidden sm:inline text-white/80">— {t("launch.subtitle")}</span>
              </p>
            </div>
            <div className="flex items-center gap-1.5 shrink-0">
              <Link to="/register?promo=AMBASSADEUR2026" data-testid="launch-cta" className="text-xs sm:text-sm bg-white text-primary-c font-semibold px-3 py-1 rounded-full hover:bg-white/90 transition-colors">
                {t("launch.cta")}
              </Link>
              <button onClick={dismiss} className="p-1 hover:bg-white/10 rounded-full transition-colors" aria-label="close" data-testid="launch-close">
                <X className="w-4 h-4" />
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
